export default __webpack_public_path__ + "static/media/menu-icon-chains.293152c8.svg";